import { httpInstancePublicProvider } from "@/services/httpInstance";
import { CommercePropertyChangeDto } from "./types";

const putCommercePropertyChange = async (
  payload: CommercePropertyChangeDto
) => {
  const endpoint = "crm_helper/v1/crm/commerce_property_change";

  try {
    const response = await httpInstancePublicProvider.put(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error("❌ Error en putCommercePropertyChange:", {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

export default putCommercePropertyChange;
